import { useEffect, useState } from 'react';
import { apiClient } from '../lib/api-client';

export type TenantMeta = {
  code: string;
  name: string;
  color?: string | null;
  logoUrl?: string | null;
};

export function useTenantMetaMap(enabled = true): Map<string, TenantMeta> {
  const [map, setMap] = useState<Map<string, TenantMeta>>(new Map());

  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;

    void apiClient.getTenants().then((response) => {
      if (cancelled) return;
      const tenants = (response?.tenants ?? []) as TenantMeta[];
      const next = new Map<string, TenantMeta>();
      for (const tenant of tenants) {
        const code = String(tenant.code || '').toLowerCase();
        if (!code) continue;
        next.set(code, tenant);
      }
      setMap(next);
    }).catch(() => {
      if (!cancelled) setMap(new Map());
    });

    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return map;
}

export function resolveTenantMeta(
  map: Map<string, TenantMeta>,
  tenantCode: string,
  fallback?: Partial<TenantMeta>,
): TenantMeta {
  const key = tenantCode.toLowerCase();
  const fromMap = map.get(key);
  return {
    code: fromMap?.code ?? fallback?.code ?? tenantCode.toUpperCase(),
    name: fromMap?.name ?? fallback?.name ?? tenantCode.toUpperCase(),
    color: fromMap?.color ?? fallback?.color ?? null,
    logoUrl: fromMap?.logoUrl ?? fallback?.logoUrl ?? null,
  };
}
